import * as React from "react";

import { Checkbox, Stack } from "@mantine/core";
import { Privilege } from "../../../types/persons/privilege";

interface PrivilegeFormProps {
  privilege: Privilege;
  onChange: Function;
}

const PrivilegeForm: React.FunctionComponent<PrivilegeFormProps> = ({
  privilege,
  onChange,
}) => {
  const addOrRemoveRole = (checked: boolean, value: Privilege) => {
    const newPrivilege = checked
      ? Privilege.addPrivilege(privilege, value)
      : Privilege.removePrivilege(privilege, value);
    onChange(newPrivilege);
  };

  const roles = Privilege.getSelectablePrivileges().map((k) => (
    <Stack gap="sm" key={k}>
      <Checkbox
        checked={Privilege.hasPrivilege(privilege, k)}
        onChange={(event) => addOrRemoveRole(event.currentTarget.checked, k)}
        label={Privilege.getIndividualString(k).toUpperCase()}
        size="sm"
      />
    </Stack>
  ));

  return <div>{roles}</div>;
};

export default PrivilegeForm;
